import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useRevenueAccess } from '../hooks/useRevenueAccess';

/** Allows Admin and Standard-rev-collection (read-only) into Revenue Collection. */
export const RevenueRoute = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuth();
  const { canViewRevenue, loading } = useRevenueAccess();

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  if (!canViewRevenue) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
